module.exports = __webpack_public_path__ + "static/img/律师报备线索规则.ba430bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/律师报备线索规则.jpg
// module id = yCp/
// module chunks = 0